<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc-title"><a id="page_vii"></a>Contents</h1>
<h2 class="toc"><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></h2>
<h2 class="toc"><a href="#/xhtml/06_Abbreviations">Abbreviations and Glossary</a></h2>
<h2 class="toc1"><a href="#/xhtml/07_Introduction">Introduction</a></h2>
<h2 class="toc-chap"><a href="#/xhtml/08_Chapter1"><span class="sp_toc-chap">Chapter 1</span> The British Military Mission to Poland in 1939</a></h2>
<h2 class="toc-chap"><span href="#/xhtml/09_Chapter2" title="Link target outside of Sample"><span class="sp_toc-chap">Chapter 2</span> The Special Operations Executive and Poland</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/10_Chapter3" title="Link target outside of Sample"><span class="sp_toc-chap">Chapter 3</span> British Subversion in French East Africa, 1941–42</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/11_Chapter4" title="Link target outside of Sample"><span class="sp_toc-chap">Chapter 4</span> On Secret Service for the Duce, 1941–43</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/12_Chapter5" title="Link target outside of Sample"><span class="sp_toc-chap">Chapter 5</span> British Radio Security and Intelligence, 1939–43</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/13_Chapter6" title="Link target outside of Sample"><span class="sp_toc-chap">Chapter 6</span> J.C. Masterman and the Security Service, 1940–72</span></h2>
<h2 class="toc2"><span href="#/xhtml/14_Bibliography" title="Link target outside of Sample">Bibliography</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Endnotes" title="Link target outside of Sample">Endnotes</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?63a75378